import { Checkbox, CheckboxProps } from '@pvh-components/checkbox';
import { Collapse } from '@pvh-components/collapse';
import { Typography } from '@pvh-components/typography';
import { ChangeEvent, useState } from 'react';
import { WithTestId } from '../../types';
import { toKebabCase } from '../../utils/casing';
import styles from './newsLetterConsent.module.css';

export interface NewsLetterProps
  extends Omit<CheckboxProps, 'children' | 'id'>,
    WithTestId {
  triggerName: string;
  excerpt: string;
  fullText: string;
}

const NewsLetterConsent = ({
  name,
  excerpt,
  triggerName,
  fullText,
  dataTestIdPrefix,
  ...rest
}: NewsLetterProps) => {
  const [visible, setVisible] = useState<boolean>(false);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    if (isChecked) {
      setVisible(true);
    }
  };

  return (
    <div
      className={styles.newsLetter}
      data-testid={toKebabCase(dataTestIdPrefix, 'newsletterConsent')}
    >
      <Checkbox
        {...rest}
        name={name}
        id={name}
        onChange={handleChange}
        data-testid={toKebabCase(
          dataTestIdPrefix,
          'newsletterConsent',
          'checkbox'
        )}
      >
        <div>
          <Typography
            variant="bodyMedium"
            hidden={visible}
            as="span"
            dataTestIdPrefix={toKebabCase(
              dataTestIdPrefix,
              'newsletterConsent'
            )}
          >
            {excerpt}&nbsp;
          </Typography>
          <Collapse
            className={styles.newsLetterCollapse}
            trigger={
              <Typography
                as="a"
                href=""
                dataTestIdPrefix={toKebabCase(dataTestIdPrefix, 'readMore')}
              >
                {!visible ? triggerName : ''}
              </Typography>
            }
            onClick={() => setVisible((e) => !e)}
            isVisible={visible}
          >
            <Typography variant="bodyMedium" as="span">
              {fullText}
            </Typography>
          </Collapse>
        </div>
      </Checkbox>
    </div>
  );
};

export default NewsLetterConsent;
